var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2703 17.6177C21.4932 16.9621 20.8688 16.1447 20.4407 15.2225C20.0127 14.3004 19.7913 13.2958 19.7921 12.2792V9.375C19.7921 5.70937 17.0692 2.675 13.5421 2.16667V1.04167C13.5421 0.765399 13.4324 0.500448 13.237 0.305097C13.0417 0.109747 12.7767 0 12.5005 0C12.2242 0 11.9593 0.109747 11.7639 0.305097C11.5686 0.500448 11.4588 0.765399 11.4588 1.04167V2.16667C7.93068 2.675 5.20881 5.70937 5.20881 9.375V12.2792C5.20921 13.2979 4.98676 14.3044 4.55705 15.228C4.12734 16.1517 3.50079 16.9701 2.72131 17.626C2.4396 17.8689 2.23881 18.192 2.14584 18.5521C2.05286 18.9122 2.07213 19.2922 2.20107 19.641C2.33001 19.9899 2.56246 20.291 2.8673 20.5041C3.17213 20.7172 3.5348 20.8321 3.90673 20.8333H21.0942C22.0994 20.8333 22.9171 20.0156 22.9171 19.0104C22.9171 18.4771 22.6849 17.9729 22.2703 17.6177ZM12.5005 25C13.4005 24.9988 14.2726 24.6873 14.9697 24.118C15.6668 23.5488 16.1464 22.7566 16.3276 21.875H8.67339C8.85455 22.7566 9.33411 23.5488 10.0312 24.118C10.7284 24.6873 11.6005 24.9988 12.5005 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.762d6f1d810d002568ad7515b2c1a664.svg";
export { ForwardRef as ReactComponent };